<h1 mat-dialog-title>Contact Us</h1>
<div mat-dialog-content *ngIf="form$ | async as form">
    <form [formGroup]="form">
        <ng-container *ngIf="displayAutocomplete$ | async">
            <mat-form-field class="w-full" appearance="fill">
                <mat-label>Tenant</mat-label>
                <input (change)="tenantOnChange()" type="text" placeholder="Pick one" aria-label="Tenant" matInput formControlName="Entity"
                    [matAutocomplete]="auto">
                <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="autoCompleteDisplayFn">
                    <mat-option *ngFor="let option of filteredTenants$ | async" [value]="option">
                        {{option.Name}}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
            <mat-form-field class="w-full" appearance="fill">
                <mat-label>Unit</mat-label>
                <input (change)="unitOnChange()" type="text" placeholder="Pick one" aria-label="Unit" matInput formControlName="Unit"
                    [matAutocomplete]="unitAuto">
                <mat-autocomplete autoActiveFirstOption #unitAuto="matAutocomplete" [displayWith]="autoCompleteDisplayFn">
                    <mat-option *ngFor="let option of filteredUnits$ | async" [value]="option">
                        {{option.Name}}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </ng-container>
        <ng-container *ngIf="!(displayAutocomplete$ | async)">
            <mat-form-field class="w-full" appearance="fill">
                <mat-label>Unit</mat-label>

                <mat-select [disabled]="(entities$ | async)?.length == 1" [compareWith]="compareFunc"
                    formControlName="Unit">
                    <mat-option *ngFor="let entity of (entities$ | async)" [value]="entity.Key">{{entity.Name}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </ng-container>
        <mat-form-field class="w-full" appearance="fill">
            <mat-label>Subject</mat-label>
            <mat-select [disabled]="(subjects$ | async)?.length == 1" [compareWith]="compareFunc"
                formControlName="Subject">
                <mat-option *ngFor="let subject of (subjects$ | async)" [value]="subject.Uri">{{subject.Subject}}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill" class="w-full">
            <mat-label>Message</mat-label>
            <textarea formControlName="Message" matInput></textarea>
        </mat-form-field>
        <div *ngIf="form.controls.Message?.errors && (form.controls.Message?.dirty || form.controls.Message?.touched)"
            class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative" role="alert">
            <div *ngIf="form.controls.Message?.errors['required']">This is required</div>
        </div>
        <mat-form-field appearance="fill" class="w-full">
            <mat-label>Reply Email</mat-label>
            <input formControlName="EmailAddress" matInput type="email" />
        </mat-form-field>
        <div *ngIf="form.controls.EmailAddress?.errors && (form.controls.EmailAddress?.dirty || form.controls.EmailAddress?.touched)"
            class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative" role="alert">
            <div *ngIf="form.controls.EmailAddress?.errors['email']">This email is not valid</div>
            <div *ngIf="form.controls.EmailAddress?.errors['required']">Email is required</div>
        </div>
    </form>
    <ng-container *ngIf="selectedImages && selectedImages.length > 0">
        <div class="flex flex-wrap items-center mx-1 mt-6">
            <div *ngFor="let selectedImage of selectedImages"
                class="flex items-center m-1 py-0.5 px-3 rounded-full text-sm font-medium text-gray-500 bg-gray-100 dark:text-gray-300 dark:bg-gray-700">
                <div>
                    {{selectedImage.name}}
                </div>
                <mat-icon class="ml-1 icon-size-4 cursor-pointer" [svgIcon]="'heroicons_solid:x-circle'"
                    (click)="clearImage(selectedImage)"></mat-icon>
            </div>
        </div>
    </ng-container>

</div>
<div mat-dialog-actions>
    <div class="grow">
        <button mat-icon-button>
            <input id="image-file-input" class="absolute h-0 w-0 opacity-0 invisible pointer-events-none" type="file"
                [multiple]="true" [accept]="'image/jpeg, image/png'" (change)="uploadImage(imageFileInput.files)"
                #imageFileInput>
            <label
                class="flex items-center justify-center w-10 h-10 rounded-full cursor-pointer hover:bg-gray-400 hover:bg-opacity-20 my-0 dark:hover:bg-black dark:hover:bg-opacity-5"
                for="image-file-input" matRipple>
                <mat-icon [svgIcon]="'heroicons_outline:photograph'"></mat-icon>
            </label>
        </button>
    </div>
    <div class="grow-0">
        <button mat-button (click)="cancel()">Cancel</button>
        <button mat-button [disabled]="!(canSubmit$ | async)" (click)="send()">Send</button>
    </div>
</div>